module.exports = __webpack_public_path__ + "media/WARNING.f7d313b6.mp3";